import { loadOperationsWithOptions } from '@app/services/api/operations';
import { OperationRegulationsEnum } from '@app/models/api/enums/OperationStatusEnum.js';

export const load = async ({ url, fetch }) => {
	const operations = await loadOperationsWithOptions(
		url,
		OperationRegulationsEnum.PSFP,
		null,
		fetch
	);
	return {
		operations,
		regulation: OperationRegulationsEnum.PSFP,
		isPrivateOperations: false
	};
};
